const defaultProjectFields = {
    diameter: '',
    depth: '',
    shellConstruction: '',
    lugCount: '',
    lugType: '',
    hardwareColor: '',
    hoops: '',
    reinforcementRings: '',
    throwOff: '',
    bearingEdge: '',
    snareWires: '',
    snareBedDepth: '',
    finishDetails: '',
    additionalNotes: '',
  };
  
  export default defaultProjectFields;